import { render, staticRenderFns } from "./TopRightArrow.vue?vue&type=template&id=453157d0&scoped=true"
import script from "./TopRightArrow.vue?vue&type=script&lang=js"
export * from "./TopRightArrow.vue?vue&type=script&lang=js"
import style0 from "./TopRightArrow.vue?vue&type=style&index=0&id=453157d0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453157d0",
  null
  
)

export default component.exports